import { Link as RouterLink } from 'react-router-dom';
import { Box, Typography, Link, BoxProps } from '@mui/material';
import { paths } from 'src/routes/paths';
import { isLoggedIn, isRoleAdmin } from 'src/utils/check-user-is-admin';
import NativesLogo from 'src/assets/images/logo/logo_icon.png';
import { useMemo } from 'react';

export interface LogoProps extends BoxProps {
  disabledLink?: boolean;
  showLogoText?: boolean;
}

export function Logo({ disabledLink = false, showLogoText = false, sx }: LogoProps) {
  const checkLoggedIn = isLoggedIn();
  const checkRoleAdmin = isRoleAdmin();

  const routes = useMemo(() => {
    if (!checkLoggedIn) {
      return `${paths.login}`;
    }
    if (checkRoleAdmin) {
      return `${paths.admin.clients.root}`;
    }
    return `${paths.customer.catalog}`;
  }, [checkLoggedIn, checkRoleAdmin]);

  const logo = (
    <Box
      component="img"
      alt="Natives Dispatcher"
      src={NativesLogo}
      sx={{ width: 40, cursor: 'pointer', objectFit: 'contain', ...sx }}
    />
  );

  if (disabledLink) {
    return logo;
  }

  return (
    <Link
      component={RouterLink}
      to={routes}
      sx={{
        display: 'flex',
        width: 'fit-content',
        alignItems: 'center',
        gap: 2,
      }}
    >
      {logo}
      {showLogoText && (
        <Typography component="span" variant="h6" pt={2} color="text.primary">
          Dispatcher
        </Typography>
      )}
    </Link>
  );
}
